export const SW_QUERY_UPDATE_EVENT = 'sw-query-update';

export const SW_ROUTER_VIEW_AVAILABLE_ATTRIBUTES = ['namespace', 'match', 'exact'];

export const SW_ROUTER_VIEW_QUERY_AVAILABLE_ATTRIBUTES = ['namespace', 'path', 'pathname', 'hash', 'search-params'];
